<div *ngIf="isStars; else default" class="filter-wrap">
    <input type="checkbox"
           [checked]="isActive">
    <label>
        <div class="ng-filter-stars">
            <img *ngFor="let star of activeStars"
                 class="ng-star"
                 src="/x-assets/img/icons/icon-y-star.svg">
        </div>
        <span class="ng-filter-value-count">({{ count }})</span>
    </label>
</div>


<ng-template #default>
    <input type="checkbox"
           [checked]="isActive">
    <label>
        {{ filterValue | uppercase }} <span class="ng-filter-value-count">({{ count }})</span>
    </label>
</ng-template>